import { MappingApi } from '../../../../../api/mappingApi';
import { TemplatesApi } from '../../../../../api/templatesApi';
import { MappingInfo } from '../../../../../interfaces/Mapping';
import { SnackbarParameters } from '../../../../../interfaces/Snackbar';
import { Template } from '../../../../../interfaces/Templates';
import withSnackbar from '../../../../../shared/components/withSnackbar';
import { SovosButton, SovosDialog, SovosDialogActions, SovosDialogContent, SovosDialogTitle } from 'mosaic-react';
import { useState } from 'react';

interface UpdateTemplateDialogProps {
	isDialogOpen: boolean;
	onClose: () => void;
	mappedColumns: MappingInfo[];
	templateInfo: any;
	forceReloadingTemplate: () => void;
	allTemplatesFetched: Template[];
	showSnackbar: (value: SnackbarParameters) => void;
	ruleType: string;
}

const UpdateTemplateDialog = (props: UpdateTemplateDialogProps) => {
	const {
		isDialogOpen,
		onClose,
		mappedColumns,
		templateInfo,
		forceReloadingTemplate,
		allTemplatesFetched,
		showSnackbar,
		ruleType,
	} = props;
	const [isUpdating, setIsUpdating] = useState(false);
	const selectedCustomTemplate = allTemplatesFetched.find(template => template.id === templateInfo?.id);

	const handleClose = () => {
		if (!isUpdating) {
			onClose();
		}
	};

	const updateProfile = (mappingId: string): void => {
		TemplatesApi.updateTemplate(templateInfo, ruleType, mappingId)
			.then(response => {
				switch (response.status) {
					case 200: {
						forceReloadingTemplate();
						showSnackbar({ message: 'Template updated successfully', variant: 'confirmation' });
						break;
					}
					case 400: {
						showSnackbar({ message: response.data.errors[0].message, variant: 'error' });
						break;
					}
					default: {
						showSnackbar({ message: 'Unable to update template. Please try again later', variant: 'error' });
						break;
					}
				}
			})
			.catch(error => console.log(error))
			.finally(() => {
				setIsUpdating(false);
				onClose();
			});
	};

	const handleSave = (): void => {
		if (isDialogOpen) {
			setIsUpdating(true);
			MappingApi.updateMappedColumns(
				selectedCustomTemplate?.mapping?.id!,
				templateInfo.calculationType!,
				mappedColumns,
				'C'
			)
				.then(({ data: { data } }) => {
					updateProfile(data);
				})
				.catch(error => {
					let errorMessage =
						error.response && error.response.data && error.response.data.errors
							? error.response.data.errors[0].message
							: 'Unable to update Template. Please try again later.';
					showSnackbar({ message: errorMessage, variant: 'error' });
					setIsUpdating(false);
					onClose();
					throw error;
				});
		}
	};

	return (
		<SovosDialog open={isDialogOpen} onClose={handleClose}>
			<SovosDialogTitle className='custom-title'>Update Template?</SovosDialogTitle>
			<SovosDialogContent>
				<p>{`${templateInfo.name} will be updated with the current column import settings and any advanced settings you may have selected.`}</p>
			</SovosDialogContent>
			<SovosDialogActions>
				<SovosButton variant='text' onClick={handleClose} disabled={isUpdating}>
					Cancel
				</SovosButton>
				<SovosButton onClick={handleSave} disabled={isUpdating}>
					Update Template
				</SovosButton>
			</SovosDialogActions>
		</SovosDialog>
	);
};

export default withSnackbar(UpdateTemplateDialog);
